<template>
    <div class="md-layout">
        <div class="md-layout-item md-size-100">

            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>assignment</md-icon>
                    </div>
                    <h4 class="title">View Staff Details
                        <div class="text-right">
                            <md-button @click="goToEdit(staff.id)" class="md-primary md-dense">
                                <md-icon>edit</md-icon>
                                Edit Staff
                            </md-button>
                            <md-button @click="goBack" class="md-primary md-dense">Back to List</md-button>
                        </div>
                    </h4>
                </md-card-header>
                <md-card-content>
                    <div>
                        <div class="md-layout">
                            <div class="md-layout-item md-size-30 md-small-size-100">
                                <div class="picture-container">
                                    <div class="picture">
                                        PICTURE

                                    </div>
                                    <h6 class="description">Choose Picture</h6>
                                </div>
                            </div>
                            <div class="md-layout-item md-size-70 mt-4 md-small-size-100">
                                <md-card-content>
                                    <items-view>
                                        <item-view label="Staff Number" :value="staff.check_no"></item-view>
                                        <item-view label="Staff Name" :value="staff.name"></item-view>
                                        <item-view label="NIDA Number" :value="staff.nida_number"></item-view>
                                        <item-view label="Phone Number" :value="staff.phone_number"></item-view>
                                        <item-view label="Email" :value="staff.email"></item-view>
                                        <item-view label="Institution" :value="staff.institution_name"></item-view>
                                        <item-view v-if="staff.user" label="Username"
                                                   :value="staff.user.name"></item-view>
                                    </items-view>
                                    <div  v-if="!staff.user && can('create-user')">
                                        <md-button @click="makeUser" class="md-primary md-dense">Create User Account</md-button>
                                        <div class="md-layout" v-if="userForm">
                                            <label class="md-layout-item md-size-25 md-form-label">Roles</label>
                                            <div class="md-layout-item">
                                                <md-field class="md-invalid">
                                                    <multiselect v-model="user.roles" id="index" label="name"
                                                                 track-by="id"
                                                                 placeholder="select roles" open-direction="bottom"
                                                                 :options="roles" :multiple="true" :searchable="true"
                                                                 :close-on-select="true"
                                                                 :options-limit="300" :max-height="600"
                                                                 :hide-selected="false">
                                                        <span slot="noResult">Oops! No elements found. Consider Refresh page.</span>
                                                    </multiselect>
                                                    <validation-error :errors="apiValidationErrors.roles"/>
                                                </md-field>
                                            </div>
                                            <md-button @click="saveUser" class="md-primary md-dense">Save User</md-button>
                                        </div>
                                    </div>

                                    <!--                                    <md-table v-model="tableData">-->
                                    <!--                                        <md-table-row >-->
                                    <!--                                            <md-table-cell >Staff Number:</md-table-cell> <md-table-cell >{{staff.check_no}} </md-table-cell>-->
                                    <!--                                        </md-table-row>-->
                                    <!--                                        <md-table-row >-->
                                    <!--                                            <md-table-cell >NIDA Number:</md-table-cell> <md-table-cell >{{staff.nida_number}}</md-table-cell>-->
                                    <!--                                        </md-table-row>-->
                                    <!--                                        <md-table-row >-->
                                    <!--                                            <md-table-cell >Phone Number:</md-table-cell> <md-table-cell > {{ staff.phone_number }} </md-table-cell>-->
                                    <!--                                        </md-table-row>-->
                                    <!--                                        <md-table-row >-->
                                    <!--                                            <md-table-cell >Email:</md-table-cell> <md-table-cell >{{staff.email}}</md-table-cell>-->
                                    <!--                                        </md-table-row>-->
                                    <!--                                        <md-table-row >-->
                                    <!--                                            <md-table-cell >Institution:</md-table-cell> <md-table-cell >{{staff.institution_name}}</md-table-cell>-->
                                    <!--                                        </md-table-row>-->
                                    <!--                                    </md-table>-->
                                </md-card-content>
                            </div>
                        </div>
                    </div>


                </md-card-content>
            </md-card>
        </div>
<!--        <div class="md-layout-item md-size-100">-->
<!--            <md-card>-->
<!--                <md-card-header class="md-card-header-icon md-card-header-green">-->
<!--                    <div class="card-icon">-->
<!--                        <md-icon>eye</md-icon>-->
<!--                    </div>-->
<!--                    <h4 class="title">Labour Details</h4>-->
<!--                </md-card-header>-->
<!--                <md-card-content>-->
<!--                    <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">-->
<!--                        <nav-tabs-card>-->
<!--                            <template slot="content">-->
<!--                                <span class="md-nav-tabs-title">Details:</span>-->
<!--                                <md-tabs class="md-info" md-alignment="left">-->
<!--                                    <md-tab id="tab-home" md-label="Permission" md-icon="bug_report">-->
<!--                                        <md-table v-model="firstTabs">-->
<!--                                            <md-table-row-->
<!--                                                    slot="md-table-row"-->
<!--                                                    slot-scope="{ item }"-->
<!--                                                    md-selectable="multiple"-->
<!--                                                    md-auto-select-->
<!--                                            >-->
<!--                                                <md-table-cell>{{ item.tab }}</md-table-cell>-->
<!--                                                <md-table-cell>-->
<!--                                                    <md-button class="md-just-icon md-simple md-primary">-->
<!--                                                        <md-icon>edit</md-icon>-->
<!--                                                        <md-tooltip md-direction="top">Edit</md-tooltip>-->
<!--                                                    </md-button>-->
<!--                                                    <md-button class="md-just-icon md-simple md-danger">-->
<!--                                                        <md-icon>close</md-icon>-->
<!--                                                        <md-tooltip md-direction="top">Close</md-tooltip>-->
<!--                                                    </md-button>-->
<!--                                                </md-table-cell>-->
<!--                                            </md-table-row>-->
<!--                                        </md-table>-->
<!--                                    </md-tab>-->
<!--                                </md-tabs>-->
<!--                            </template>-->
<!--                        </nav-tabs-card>-->
<!--                    </div>-->
<!--                </md-card-content>-->
<!--            </md-card>-->
<!--        </div>-->
    </div>
</template>
<script>
import { NavTabsCard, } from '@/components';
import ItemsView from '../../../components/Inputs/ItemsView';
import ItemView from '../../../components/Inputs/ItemView';
import formMixin from '@/mixins/form-mixin';
import ValidationError from '../../../components/ValidationError';
import Multiselect from 'vue-multiselect';


export default {
    components: {
        ItemView,
        ItemsView,
        NavTabsCard,
        Multiselect, ValidationError
    },
    mixins: [formMixin],
    data () {
        return {
            staff: {
                type: 'staffs',
                check_no: null,
                nida_number: null,
                phone_number: null,
                vendor_id: null,
                vendor_name: null,
                email: null,
                gender: null,
                uuid: null
            },
            user: {},
            roles: [],
            userForm: false,
            firstTabs: [
                {
                    tab: 'Sign contract for "What are conference organizers afraid of?"'
                },
                {
                    tab: 'Lines From Great Russian Literature? Or E-mails From My Boss?'
                },
                {
                    tab:
                            'Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit'
                }
            ],
            secondTabs: [
                {
                    tab: 'Sign contract for "What are conference organizers afraid of?"'
                },
                {
                    tab: 'Lines From Great Russian Literature? Or E-mails From My Boss?'
                },
                {
                    tab:
                            'Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit'
                }
            ],
            thirdTabs: [
                {
                    tab: 'Sign contract for "What are conference organizers afraid of?"'
                },
                {
                    tab: 'Lines From Great Russian Literature? Or E-mails From My Boss?'
                },
                {
                    tab:
                            'Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit'
                }
            ],
            fourthTabs: [
                {
                    tab: 'Sign contract for "What are conference organizers afraid of?"'
                },
                {
                    tab: 'Lines From Great Russian Literature? Or E-mails From My Boss?'
                },
                {
                    tab:
                            'Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit'
                }
            ],
        };
    },
    created () {
        this.get();
    },
    computed: {
        shoppingTotal () {
            return this.shoppingCartTable.reduce((accumulator, current) => {
                return accumulator + current.amount;
            }, 0);
        }
    },
    methods: {
        async get () {
            try {
                const id = this.$route.params.id;
                let params = { id:id, include:'user' };
                await this.$store.dispatch('staffs/get', params);
                this.staff = this.$store.getters['staffs/staff'];
            } catch (e) {
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, something went wrong!'
                );
            }
        },
        async makeUser () {
            this.userForm = !this.userForm;
            await this.getRoles();
        },
        async saveUser () {
            this.user.type = 'users';
            this.user.email = this.staff.email;
            this.user.name = this.staff.name ? this.staff.name : this.staff.check_no;
            this.user.model_type = 'Staff';
            this.user.model_id = this.staff.id;
            try {
                await this.$store.dispatch('users/add', this.user);
                this.user = await this.$store.getters['users/user'];
                this.staff.user = this.user;
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.$store.dispatch(
                        'alerts/error',
                        e.response.data.errors[0].title
                    );
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.$store.dispatch(
                        'alerts/error',
                        'Oops, something went wrong!'
                    );
                    this.setApiValidation(e.response.data.errors);
                }
            }
        },
        async getRoles () {
            await this.$store.dispatch('roles/list').then(() => {
                this.roles = this.$store.getters['roles/list'];
                this.roles = this.roles.map(role => {
                    role.type = 'roles';
                    return role;
                });

                console.log(this.roles);
            });
        },
        goToEdit (id) {
            this.$router.push({ name: 'Edit Staff', params: { id } });
        },
        goBack () {
            this.$router.push({ name: 'Staffs List' });
        },

    }
};
</script>
<style lang="scss" scoped>
    .text-right .md-table-cell-container {
        display: flex;
        justify-content: flex-end;
    }

    .md-table .md-table-head:last-child {
        text-align: right;
    }

    .table-stats {
        display: flex;
        align-items: center;
        text-align: right;
        flex-flow: row wrap;

        .td-price .td-total {
            display: inline-flex;
            font-weight: 500;
            font-size: 1.0625rem;
            margin-right: 50px;
        }

        &.table-striped .td-price {
            border-bottom: 0;
        }

        .td-price {
            font-size: 26px;
            border-top: 1px solid #ddd;
            border-bottom: 1px solid #ddd;
        }

        .td-price,
        > div {
            flex: 0 0 100%;
            padding: 12px 8px;
        }
    }

    .table-shopping .md-table-head:nth-child(5),
    .table-shopping .md-table-head:nth-child(7),
    .table-shopping .md-table-head:nth-child(6) {
        text-align: right;
    }
</style>
